import React from 'react';
import { TextField } from '@iclinic/design-system';
import { FormikErrors, FormikTouched } from 'formik';

import { ClinicBillingField } from './ClinicBillingFields';
import BRAZIL_STATES_INITIALS from 'shared/constants/brStates';
import { ClinicBillingType } from '../types';

export type BillingAddressFieldsProps = Readonly<{
  values: ClinicBillingType;
  errors: FormikErrors<ClinicBillingType>;
  touched: FormikTouched<ClinicBillingType>;
  handleChange: React.ChangeEventHandler<HTMLInputElement>;
  zipCodeValue: string;
  zipCodeOnChange: React.ChangeEventHandler<HTMLInputElement>;
}>;

export function BillingAddressFields({
  values,
  errors,
  touched,
  handleChange,
  zipCodeValue,
  zipCodeOnChange,
}: BillingAddressFieldsProps) {
  return (
    <>
      <TextField
        id="billing_zip"
        label="CEP"
        name="billing_zip"
        placeholder="12345-678"
        value={zipCodeValue}
        onChange={zipCodeOnChange}
        error={touched.billing_zip && !!errors.billing_zip}
        helperText={touched.billing_zip && errors.billing_zip}
        style={{ gridArea: 'cep' }}
      />

      <ClinicBillingField
        id="address"
        name="billing_address"
        label="Endereço"
        placeholder="Rua das Flores"
        gridArea="address"
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
      />

      <ClinicBillingField
        id="number"
        name="billing_number"
        label="Número"
        placeholder="55"
        gridArea="number"
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
      />

      <ClinicBillingField
        id="billing_address2"
        label="Complemento"
        name="billing_address2"
        placeholder="Apartamento 123, Bloco A"
        values={values}
        handleChange={handleChange}
        errors={errors}
        touched={touched}
        gridArea="complement"
      />

      <ClinicBillingField
        id="neighborhood"
        name="billing_neighborhood"
        label="Bairro"
        placeholder="Centro"
        gridArea="neighborhood"
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
      />

      <ClinicBillingField
        id="city"
        name="billing_city"
        label="Cidade"
        placeholder="São Paulo"
        gridArea="city"
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
      />

      <TextField
        id="billing_state"
        label="Estado"
        name="billing_state"
        value={values.billing_state}
        onChange={handleChange}
        error={touched.billing_state && !!errors.billing_state}
        helperText={touched.billing_state && errors.billing_state}
        select
        SelectProps={{ native: true }}
        style={{ gridArea: 'state' }}
      >
        <option value="">Selecione</option>
        {BRAZIL_STATES_INITIALS.map((state) => (
          <option value={state} key={state}>
            {state}
          </option>
        ))}
      </TextField>
    </>
  );
}
